import { render, staticRenderFns } from "./SimulationAssessment.vue?vue&type=template&id=05cba103&scoped=true"
import script from "./SimulationAssessment.vue?vue&type=script&lang=js"
export * from "./SimulationAssessment.vue?vue&type=script&lang=js"
import style0 from "./SimulationAssessment.vue?vue&type=style&index=0&id=05cba103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cba103",
  null
  
)

export default component.exports